import React from 'react';
import PropTypes from "prop-types";

import { Container, Segment, Header } from "semantic-ui-react";

const ProductDescription = ({ content }) => {
  return (
    <Segment basic textAlign='center'>
      <Header as='h3'>{content.headline}</Header>
      <Container textAlign='left'>
        <p>{content.paragraph}</p>
      </Container>
    </Segment>
  );
};

ProductDescription.propTypes = {
  content: PropTypes.shape({
    iconName: PropTypes.string,
    headline: PropTypes.string.isRequired,
    paragraph: PropTypes.string.isRequired
  })
}

export default ProductDescription;



// WEBPACK FOOTER //
// ./src/Product/ProductDescription.js